import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
  useTheme,
  Paper,
  TableBody,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { GET } from "../Generic/CrudRequest";
import Icons from "../../Utils/Icons";
import { LoadModel } from "./LoadModel";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function DetailsLoads({ config }) {
  const theme = useTheme();
  const location = useLocation();
  const { t } = useTranslation();
  const [loadData, setLoadData] = useState(null);
  const [estatus, setEstatus] = useState("");

  useEffect(() => {
    if (location.pathname.includes("/Cargas/Detalle")) {
      const loadId = getLoadIdFromPath(location.pathname);
      getLoadById(loadId);
    }
  }, [location.pathname]);

  const getLoadIdFromPath = (pathname) => {
    const parts = pathname.split("/");
    return parts[parts.length - 1];
  };

  const getLoadById = async (loadId) => {
    const dataLoad = await GET(`${config.url}/api/Carriers/${loadId}`);
    const updateDataLoad = new LoadModel(dataLoad);

    setLoadData(updateDataLoad);
    if (updateDataLoad?.estatus === true) {
      setEstatus(t("loads.status.active"));
    } else {
      setEstatus(t("loads.status.inactive"));
    }
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <CardContent
          sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        >
          <Icons
            iconName="ArrowBack"
            fontSize="large"
            style={{
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              marginRight: 20,
            }}
            to="/Cargas"
            tooltip={t("loads.details.back")}
          />
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("loads.details.title")}
          </Typography>
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("loads.details.loadInfo")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("loads.details.client")}
                  name="cliente"
                  variant="standard"
                  fullWidth
                  value={loadData?.cliente ? loadData.cliente : t("loads.details.notAvailable")}
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("loads.details.status")}
                  name="estatus"
                  variant="standard"
                  fullWidth
                  value={estatus}
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("loads.details.assemblyLocation")}
                  name="ubicacionMontaje"
                  variant="standard"
                  fullWidth
                  value={
                    loadData?.ubicacion ? loadData.ubicacion : t("loads.details.notAvailable")
                  }
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("loads.details.requestDate")}
                  name="fechaSolicitud"
                  variant="standard"
                  fullWidth
                  value={
                    loadData?.fechaSolicitud
                      ? moment
                          .utc(loadData.fechaSolicitud)
                          .local()
                          .format("MM/DD/YYYY HH:mm A")
                      : t("loads.details.notAvailable")
                  }
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label={t("loads.details.load")}
                  name="noCarga"
                  variant="standard"
                  fullWidth
                  value={loadData?.noCarga ? loadData.noCarga : t("loads.details.notAvailable")}
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ marginTop: 2 }}>
              <Grid item xs={12}>
                <TextField
                  label={t("loads.details.observations")}
                  name="observaciones"
                  variant="standard"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={loadData?.observaciones || ""}
                  InputProps={{ disableUnderline: true }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card
          variant="outlined"
          sx={{
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            border: "1px solid rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            marginTop: 2,
          }}
        >
          <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
            <Typography
              variant="h5"
              sx={{
                flex: "1",
                color: theme.palette.primary.main,
              }}
            >
              {t("loads.details.addedUnits")}
            </Typography>
            <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            <Paper
              sx={{
                width: "100%",
                margin: "auto",
                overflow: "hidden",
                boxShadow: "none",
                border: "none",
              }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }} key="orden">
                        {t("loads.details.order")}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }} key="vin">
                        {t("loads.search.vin")}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }} key="modelo">
                        {t("loads.details.model")}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }} key="marca">
                        {t("loads.details.brand")}
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }} key="destino">
                        {t("loads.details.destination")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadData?.unidades.map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        <TableCell>
                          {row.orden !== null && row.orden !== "" ? (
                            row.orden
                          ) : (
                            <i>{t("loads.details.notAvailable")}</i>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.vin !== null && row.vin !== "" ? (
                            row.vin
                          ) : (
                            <i>{t("loads.details.notAvailable")}</i>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.modelo !== null && row.modelo !== "" ? (
                            row.modelo
                          ) : (
                            <i>{t("loads.details.notAvailable")}</i>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.marca !== null && row.marca !== "" ? (
                            row.marca
                          ) : (
                            <i>{t("loads.details.notAvailable")}</i>
                          )}
                        </TableCell>
                        <TableCell>
                          {row.destino !== null && row.destino !== "" ? (
                            row.destino
                          ) : (
                            <i>{t("loads.details.notAvailable")}</i>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
}
